<script setup lang="ts">
import OmniAidLogo from "@/components/icons/OmniAidLogoCircle.vue";
import AppConfig from "@/layout/common/AppConfig.vue";
</script>

<template>
  <AppConfig location="system" />
  <div
    class="overflow-hidden bg-surface-50 dark:bg-surface-950 w-full min-h-screen"
  >
    <div
      class="landing-container min-h-screen flex flex-col gap-20 justify-between"
    >
      <div class="flex items-end gap-16 mb-12">
        <div class="flex-1 relative">
          <svg
            class="absolute right-0 bottom-0 [&_stop]:[stop-color:var(--p-surface-200)] dark:[&_stop]:[stop-color:var(--p-surface-800)]"
            width="634"
            height="132"
            viewBox="0 0 634 132"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M633.667 129C633.667 130.473 632.473 131.667 631 131.667C629.527 131.667 628.333 130.473 628.333 129C628.333 127.527 629.527 126.333 631 126.333C632.473 126.333 633.667 127.527 633.667 129ZM-228.095 -136.574C-228.33 -136.718 -228.404 -137.026 -228.26 -137.262C-228.115 -137.497 -227.807 -137.571 -227.572 -137.426L-228.095 -136.574ZM199.513 125.451L199.774 125.025L199.513 125.451ZM631 129.5H212.072V128.5H631V129.5ZM199.251 125.877L-228.095 -136.574L-227.572 -137.426L199.774 125.025L199.251 125.877ZM212.072 129.5C207.546 129.5 203.108 128.246 199.251 125.877L199.774 125.025C203.474 127.297 207.731 128.5 212.072 128.5V129.5Z"
              fill="url(#paint0_linear_101_3698)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_101_3698"
                x1="-227.833"
                y1="-3.99999"
                x2="631"
                y2="-3.99999"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-opacity="0" />
                <stop offset="0.095" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          class="translate-y-10 p-2 rounded-full bg-surface-50 dark:bg-surface-950 border"
        >
          <div
            class="w-20 h-20 rounded-full flex items-center justify-center bg-surface-0 dark:bg-surface-900 shadow-[0px_129.205px_36.493px_0px_rgba(44,54,87,0.00),_0px_82.849px_33.534px_0px_rgba(44,54,87,0.01),_0px_46.356px_27.616px_0px_rgba(44,54,87,0.05),_0px_20.712px_20.712px_0px_rgba(44,54,87,0.09),_0px_4.932px_11.836px_0px_rgba(44,54,87,0.10)]"
          >
            <OmniAidLogo size="70" />
          </div>
        </div>
        <div class="flex-1 relative">
          <svg
            class="absolute left-0 bottom-0 [&_stop]:[stop-color:var(--p-surface-200)] dark:[&_stop]:[stop-color:var(--p-surface-800)]"
            xmlns="http://www.w3.org/2000/svg"
            width="634"
            height="130"
            viewBox="0 0 634 130"
            fill="none"
          >
            <path
              d="M0.333333 127C0.333333 128.473 1.52724 129.667 3 129.667C4.47276 129.667 5.66667 128.473 5.66667 127C5.66667 125.527 4.47276 124.333 3 124.333C1.52724 124.333 0.333333 125.527 0.333333 127ZM862.095 -138.574C862.33 -138.718 862.404 -139.026 862.26 -139.262C862.115 -139.497 861.807 -139.571 861.572 -139.426L862.095 -138.574ZM434.487 123.451L434.226 123.025L434.487 123.451ZM3 127.5H421.928V126.5H3V127.5ZM434.749 123.877L862.095 -138.574L861.572 -139.426L434.226 123.025L434.749 123.877ZM421.928 127.5C426.454 127.5 430.892 126.246 434.749 123.877L434.226 123.025C430.526 125.297 426.269 126.5 421.928 126.5V127.5Z"
              fill="url(#paint0_linear_6688_24071)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_6688_24071"
                x1="861.833"
                y1="-5.99999"
                x2="3"
                y2="-5.99999"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-opacity="0" />
                <stop offset="0.095" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
      <RouterView />
      <div class="flex items-end gap-12"></div>
    </div>
  </div>
</template>
